import React from 'react'
import { Page } from '../../../../shared'
import { SedaHeader } from './header'
import {
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import SedaFooter from './footer'
import { SedaDataLoader } from '../../loader'
import SedaExplorer from './SedaExplorer'
import { SedaMenu } from '../../menu'
import { SedaRouting } from '../../routing'
import SedaShortcuts from './SedaShortcuts'
import { useUiStore } from '../hooks'

const useStyles = makeStyles(theme => ({
  offset: {
    ...theme.mixins.toolbar,
    minHeight: 56,
    [theme.breakpoints.down('sm')]: {
      minHeight: 97
    }
  },
  root: {
    overflow: 'hidden'
  },
  body: {
    overflow: 'hidden'
  },
  embed: {
    '& $offset': {
      minHeight: 56
    },
    '& h6, & h6 + p': {
      'max-width': 'unset'
    },
  },
  screenshotForPdf: {
     '& *': {
        fontSize: '30px !important'
      },
      '& header, & header + div': {
        display: 'none'
      },
      '& footer': {
        display: 'none'
      },
      '& .side-panel-group': {
        display: 'none'
      },
      '& .scatterplot[role="img"]': {
        top: 150,
        bottom: 55,
        left: 48,
        right: 64,
      },
      '& .book-ends svg': {
        display: 'none'
      },
      '& .scatterplot__header': {
        top: -125,
      },
      '& .scatterplot__axis--x': {
        bottom: -50
      }
  }
}))

const SedaApp = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isEmbed = useUiStore(state => state.isEmbed)
  return (
    <Page
      className={(classes.root, {
        [classes.embed]: isEmbed,
        // Only enable this when creating 2034x1248 screenshots to include in PDF export
        // [classes.screenshotForPdf]: true
      })}>
      <SedaShortcuts />
      <SedaRouting />
      <SedaHeader isMobile={isMobile} />
      <div className={classes.offset} />
      <SedaMenu />
      <SedaDataLoader />
      <SedaExplorer className={classes.body} />
      <SedaFooter />
    </Page>
  )
}

SedaApp.propTypes = {}

export default SedaApp
